import firebase from "firebase";

const firebaseConfig = {
  apiKey: "AIzaSyBPNq-9lRPDiOqtXyyBGs9PanJawwsPVVI",
  authDomain: "finult.firebaseapp.com",
  databaseURL: "https://finult.firebaseio.com",
  projectId: "finult",
  storageBucket: "finult.appspot.com",
  messagingSenderId: "778139956278",
  appId: "1:778139956278:web:89e7337980c2fab5c1d497",
  measurementId: "G-YWNWR1E303"
};

// Initialize Firebase
const firebaseApp = firebase.initializeApp(firebaseConfig);
firebase.analytics();

export default firebaseApp.firestore();
